import { BehaviorSubject } from 'rxjs';
import { TOKEN } from '@core/constants/tokenService.constant';
import { URL } from '@core/constants/url.constant';
import { ApiValidate } from '@core/decorators/ApiValidate.decorator';
import { Singleton } from '@core/decorators/Singleton.decorator';
import { tokenSchema } from '@core/schemas/tokenService.schema';
import { apiService } from './Api.service';
import type { TToken } from '@core/models/tokenService.model';

@Singleton
class TokenService {
  private readonly TOKEN = TOKEN;
  private readonly isAuthenticated$ = new BehaviorSubject(Boolean(this.storedToken));

  @ApiValidate(tokenSchema)
  public refreshToken() {
    return apiService.post<TToken>({
      url: URL.tokenRefresh,
      dto: { refreshToken: this.storedToken?.refreshToken }
    });
  }

  public get storedToken() {
    const token = localStorage.getItem(this.TOKEN);

    try {
      if (token) {
        return JSON.parse(token) as TToken;
      }
    } catch (_error) {
      return null;
    }

    return null;
  }

  public setTokens(tokens: TToken) {
    localStorage.setItem(this.TOKEN, JSON.stringify(tokens));
    if (!this.isAuthenticated$.getValue()) {
      this.isAuthenticated$.next(true);
    }
  }

  public removeTokens() {
    localStorage.removeItem(this.TOKEN);
    this.isAuthenticated$.next(false);
  }

  public get isAuthenticated() {
    return this.isAuthenticated$;
  }

  public get getAccessToken() {
    if (this.storedToken) {
      return this.storedToken.accessToken;
    }
    return null;
  }

  public get getRefreshToken() {
    if (this.storedToken) {
      return this.storedToken.refreshToken;
    }
    return null;
  }
}

const tokenService = new TokenService();

export { tokenService };
